import { render, staticRenderFns } from "./taskTypeDialog.vue?vue&type=template&id=6c2a1f80&"
import script from "./taskTypeDialog.vue?vue&type=script&lang=js&"
export * from "./taskTypeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports